import React from 'react';
import Loadable from 'react-loadable'

function Loading() {
    return <div className="loading">
        
    </div>;
}

const MagazinHome = Loadable({
    loader: () => import('./Views/Magazine/Home_magazine/home_magazine.js'),
    loading: Loading
});
const AllPublishingRequests = Loadable({
    loader: () => import('./Views/Magazine/PublishingRequests/AllPublishingRequests/AllPublishingRequests.js'),
    loading: Loading
});
const PublishingRequestsDetails = Loadable({
    loader: () => import('./Views/Magazine/PublishingRequests/PublishingRequestsDetails/PublishingDetails.js'),
    loading: Loading
});
const Volumes = Loadable({
    loader: () => import('./Views/Magazine/Volumes/volumes.js'),
    loading: Loading
});

const ScientificPormotionHome = Loadable({
    loader: () => import('./Views/ScientificPormotion/Home_promotion/home_promotion'),
    loading: Loading
});

const PublicationRequest = Loadable({
    loader: () => import('./Views/Publication/publication.js'),
    loading: Loading
});

const PromotionRequest = Loadable({
    loader: () => import('./Views/PromotionRequest/pormotion.js'),
    loading: Loading
});

const ProfileSetting = Loadable({
    loader: () => import('./Views/ProfilePage/profilepage.js'),
    loading: Loading
});
const Aboutus = Loadable({
    loader: () => import('./Views/Aboutus/Aboutus'),
    loading: Loading
});
const Contactus = Loadable({
    loader: () => import('./Views/Contactus/Contactus'),
    loading: Loading
});

const Members = Loadable({
    loader: () => import('./Views/Members/Members'),
    loading: Loading
});

const PublishRules = Loadable({
    loader: () => import('./Views/PublishRules/PublishRules'),
    loading: Loading
});

const Regulations = Loadable({
    loader: () => import('./Views/Regulations/Regulations'),
    loading: Loading
});

const AllNews = Loadable({
    loader: () => import('./Views/News/AllNews/AllNews'),
    loading: Loading
});

const SingleNew = Loadable({
    loader: () => import('./Views/News/SingleNew/SingleNew'),
    loading: Loading
});

//forms
const ViewForms = Loadable({
    loader: () => import('./Views/Magazine/Forms/ViewForms/viewforms.js'),
    loading: Loading
});

const routes = [
    { path: '/Magazin', exact: true, name: 'Magazin Home', component: MagazinHome },
    { path: '/magazine/allpublishing', exact: true, name: 'Magazin Home', component: AllPublishingRequests },
    { path: '/magazine/publishingrequests', exact: true, name: 'Magazin Home', component: PublishingRequestsDetails },
    { path: '/volumes/:type', exact: true, name: 'Magazin Home', component: Volumes },

    { path: '/Promotion', exact: true, name: 'Scientific Pormotion Home', component: ScientificPormotionHome },
    { path: '/PublicationRequest', exact: true, name: 'PublicationRequest', component: PublicationRequest },
    { path: '/PromotionRequest', exact: true, name: 'PromotionRequest', component: PromotionRequest },
    { path: '/ProfileSetting', exact: true, name: 'ProfileSetting', component: ProfileSetting },
    

    { path: '/Aboutus', exact: true, name: 'Aboutus', component: Aboutus },
    { path: '/Contactus', exact: true, name: 'Contactus', component: Contactus },
    { path: '/Members', exact: true, name: 'Members', component: Members },
    { path: '/PublishRules', exact: true, name: 'PublishRules', component: PublishRules },
    { path: '/Regulations', exact: true, name: 'Regulations', component: Regulations },
    { path: '/AllNews', exact: true, name: 'AllNews', component: AllNews },
    { path: '/SingleNew', exact: true, name: 'SingleNew', component: SingleNew },

    //forms
    { path: '/ViewForms', exact: true, name: 'ViewForms', component: ViewForms },

    
    
]

export default routes;